import qs from 'qs'
import axios from '@/api/apiClient'

/**
 * 基础数据api
 */
const api = {
  /** 地区 */
  continent: '/api/base/area/continent',
  country: '/api/base/area/country',
  province: '/api/base/area/state',
  city: '/api/base/area/city',
  region: '/api/base/area/region',
  biddingRegion: '/api/base/area/tree',
  /** 行业 */
  exhibition: '/api/base/industry/exhibition',
  meeting: '/api/base/industry/meeting',
  model: '/api/base/industry/moxing',
  news: '/api/base/industry/info',
  /** 类别 */
  CategoryModel: '/api/base/category/moxing',
  CategoryDesigner: '/api/base/category/designer',
  CategoryBuild: '/api/base/category/srprovider',
  /** 字典 */
  kkfx: '/api/base/dictionary/kkfx',
  mjdx: '/api/base/dictionary/mjdx',
  // 配置
  config: '/api/base/settingvalue/assistcontent',

  // 企业信息编辑
  // 企业员工数
  company_employee: '/api/base/dictionary/company_employee',
  // 企业性质
  company_nature: '/api/base/dictionary/company_nature',

  // 获取定位
  location: '/api/recruitment/location',
  // 热门城市
  hotCity: '/api/base/area/city/hot',
}
export default api
export const getConfigContent = () => {
  return axios.$get(api.config)
}
/**
 * 服务器时间
 */
export const getServerTime = () => {
  return axios.$get('/api/base/dictionary/current')
}
// koa扩展接口
// 获取五层地区的组件数据
export const getRegionOption = () => {
  return axios.$get('/koa/region')
}
// 获取所有行业的基础数据
export const getIndustryOption = () => {
  return axios.$get('/koa/industry')
}
// 获取所有分类的基础数据
export const getCategoryOption = () => {
  return axios.$get('/koa/category')
}
// 获取所有分类的基础数据
export const getDictionaryOption = () => {
  return axios.$get('/koa/dictionary')
}
// 获取招标地区数据
export const getBiddingRegion = () => {
  return axios.$get(`${api.biddingRegion}`)
}
// 获取六大洲
export const getContinent = () => {
  return axios.$get(`${api.continent}`)
}
// 获取国家
export const getCountry = () => {
  return axios.$get(`${api.country}`)
}
// 获取省州
export const getProvince = () => {
  return axios.$get(`${api.province}`)
}
// 获取市
export const getCity = () => {
  return axios.$get(`${api.city}`)
}
// 获取地区
export const getrRegion = () => {
  return axios.$get(`${api.region}`)
}

// 获取展览行业
export const getIndustryExhibition = () => {
  return axios.$get(`${api.exhibition}`)
}
// 获取会议行业
export const getIndustryMeeting = () => {
  return axios.$get(`${api.meeting}`)
}
// 获取模型行业
export const getIndustryModel = () => {
  return axios.$get(`${api.model}`)
}
// 获取资讯行业
export const getIndustryNews = () => {
  return axios.$get(`${api.news}`)
}

export const getCommonIndustry = () => {
  return axios.$get('/api/industry/common/all')
}

// 获取模型类别
export const getCategoryModel = () => {
  return axios.$get(`${api.CategoryModel}`)
}
// 获取设计师类别
export const getCategoryDesigner = () => {
  return axios.$get(`${api.CategoryDesigner}`)
}
// 获取展厅工程商类别
export const getCategoryBuild = () => {
  return axios.$get(`${api.CategoryBuild}`)
}

// 获取开口方向
export const getDictionaryKKFX = () => {
  return axios.$get(`${api.kkfx}`)
}
// 获取面积大小
export const getDictionaryMJDX = () => {
  return axios.$get(`${api.mjdx}`)
}

// 获取手机区号
export const getCountrycode = () => {
  return axios.$get('/json/countrycode.json')
}

export const getCompanyEmployee = () => {
  return axios.$get(`${api.company_employee}`)
}
export const getCompanyNature = () => {
  return axios.$get(`${api.company_nature}`)
}

export const getLocation = (query) => {
  return axios.$get(`${api.location}${query ? `?${qs.stringify(query)}` : ''}`)
}

// 获取热门城市
export const getHotCity = (query) => {
  return axios.$get(`${api.hotCity}${query ? `?${qs.stringify(query)}` : ''}`)
}

// 招商服务标签列表
export const getMerchantsTag = () => {
  return axios.$get('/api/base/dictionary/merchants-tag')
}

// 判断用户是否在中国
export const getIsInChina = () => {
  return axios.$get('/api/base/area/isChina')
}

// 获取展览状态
export const getExhibitionStatus = () => {
  return axios.$get('/api/exhibition/info/status/constant')
}
// 热门国家
export const getPopularCountry = () => {
  return axios.$get('/api/sms/cloud/client/hot/country/list')
}

// 中国热门城市
export const getChinaPopularCountry = () => {
  return axios.$get('/api/sms/cloud/client/hot/city/list')
}

// 国外国家列表（按国家名拼音首字母分组）
export const getAlphabeticallyGroupedCountry = async () => {
  const params = await axios.$get('/api/sms/cloud/client/foreign/country/list/gbl')
  if (params.code === 0) {
    params.data.map((item) => {
      item.countryList.map((item2) => {
        item2.letter = item.letter
      })
    })

    return params
  }
  return params
}

// 注册资本单位列表
export const getInfoRegisterUnit = () => {
  return axios.$get('/api/company/info/registerUnit')
}

// POI地址检索
export const getPoiAddress = (query) => {
  return axios.$get(`/amap/v3/place/text?${qs.stringify(query)}`)
}

// 供应链临时存储
export const getSupplyData = (query) => {
  return axios.$get(`/koa/supply-data/get/${query.supplyChainId}`)
}
